/**
 * Created by asiulik on 22.03.2018.
 */

define(['jquery'], function ($) {


    function ParketSortiment(layout) {

        var _this = this;
        this.layout = layout;

    }

    ParketSortiment.prototype.init = function () {

        var _this = this;
        this.$formatList = $('.formats__list');

        if (!this.$formatList.length) return;

        if (this.layout.small) {
            this.createSlider();
        }

        this.layout.on('reload', function () {

            if (_this.layout.small) {
                if (_this.$formatList.hasClass('slick-initialized')) return;
                _this.createSlider();
            } else {

                if (!_this.$formatList.hasClass('slick-initialized')) return;
                _this.removeSlider();
            }

        });

    };

    ParketSortiment.prototype.reload = function () {

        this.layout.off('reload.parketsortiment');
    };

    ParketSortiment.prototype.removeSlider = function () {
        try {
            this.$formatList.slick('unslick');
        } catch (e) {
        }
    };

    ParketSortiment.prototype.createSlider = function () {
        this.$formatList.slick({
            infinite: false,
            arrows: false,
            centerPadding: '20px',
            centerMode: true,
            slidesToShow: 1,
            slidesToScroll: 1
        });
    };

    return ParketSortiment;

});



// WEBPACK FOOTER //
// ./Private/Scripts/pages/parketsortiment.js